import { pagProps, navProps, fullNavProps, gv2Props, cv2Props, gv3Props, gv4Props, gv5Props, autoplayProps } from "./defaultSettingProps";

export const SlidersProps = {
  pics: {
    element: '.pics-slider',
    props: {
      ...fullNavProps,
      centeredSlides: true,
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 0,
        stretch: 60,
        depth: 100,
        modifier: 3,
      },
      loop: false,
      allowTouchMove: false,
      slidesPerView: 'auto',
      watchOverflow: true,
      breakpoints: {
        576: {
          coverflowEffect: {
            stretch: 75,
          },
        },
        768: {
          coverflowEffect: {
            stretch: 70,
          },
        },
        1440: {
          coverflowEffect: {
            stretch: 90,
          },
        },
      }
    }
  },
  press: {
    element: '.press-slider',
    props: {
      ...pagProps,
      spaceBetween: 32,
      slidesPerView: 1,
      slidesPerColumn: 2,
      slidesPerColumnFill: 'row',
      watchOverflow: true,
      breakpoints: {
        768: {
          ...cv2Props,
        },
        1200: {
          ...cv2Props,
          spaceBetween: 48,
        }
      }
    }
  },
  testimonials_calc: {
    element: '.testimonials-slider-calc',
    props: {
      ...fullNavProps,
      autoplay: {
        delay: 2000,
      },
      loop: true,
      slidesPerView: 1,
      watchOverflow: true,
      spaceBetween: 20,
    }
  },
  testimonials: {
    element: '.testimonials-slider',
    props: {
      ...fullNavProps,
      autoplay: {
        ...autoplayProps,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      slidesPerView: 1,
      watchOverflow: true,
    }
  },
  cards: {
    element: '.cards-slider',
    props: {
      ...pagProps,
      centeredSlides: true,
      grabCursor: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      watchOverflow: true,
      breakpoints: {
        576: {
          centeredSlides: false,
          slidesPerGroup: 2,
        },
        768: {
          centeredSlides: false,
          slidesPerGroup: 3,
        },
        992: {
          ...gv4Props,
          centeredSlides: false,
        },
        1200: {
          ...gv5Props,
          centeredSlides: false,
        },
      }
    }
  },
  webdoor: {
    element: '.webdoor-slider',
    props: {
      ...pagProps,
      grabCursor: true,
      watchOverflow: true,
      autoplay: {
        ...autoplayProps,
        disableOnInteraction: false,
      },
    }
  },
  // o bloco desse componente foi desativado por enquanto
  products: {
    element: '.products-cards-slider',
    props: {
      ...pagProps,
      ...gv2Props,
      centerInsufficientSlides: true,
      spaceBetween: 20,
      watchOverflow: true,
      breakpoints: {
        992: {
          ...gv3Props,
        },
        1200: {
          ...gv4Props,
        },
        1440: {
          ...gv5Props,
        },
      }
    }
  },
  posts: {
    element: '.category-posts-slider',
    props: {
      ...navProps,
      slidesPerView: 'auto',
      watchOverflow: true,
      breakpoints: {
        768: {
          ...gv2Props,
        },
        992: {
          ...gv3Props,
        },
        1440: {
          ...gv4Props,
        }
      }
    }
  }
};